import * as R from "ramda";
import { createSelector } from "reselect";

import { getItems, Patient } from "redux/modules/patients";
import getInstitutionKey from '../../selectors/getInstitutionKey';

const getFilteredByFIOPatients = createSelector(
  R.path(["patients"]),

  getItems as any
) as unknown as () => Patient[];

//Фильтруем пациентов по ключу учреждения, чтобы в список не попали чужие пациенты.
//Данные по ним заносятся в общий стор, при открытии страницы запроса на странице "новые клиенты".
export default createSelector(
  getFilteredByFIOPatients,
  getInstitutionKey,

  (filteredPatients, key) => {
    return filteredPatients.filter(patient => patient.___territory === key);
  }
)